import Vue from 'vue'
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import SuiVue from 'semantic-ui-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import './../node_modules/semantic-ui-offline/semantic.min.css';
import VueMobileDetection from "vue-mobile-detection";
import 'sweetalert2/dist/sweetalert2.min.css';
import vuetify from '@/plugins/vuetify'
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueMobileDetection);
const optionsSwal = {
  confirmButtonColor: 'rgb(115,141,40)',
  cancelButtonColor: 'rgba(0, 0, 0, 0.6);',
};

Vue.use(VueAxios, Axios)
Vue.use(VueSweetalert2, optionsSwal)
Vue.use(SuiVue)
Vue.use(VueTour)

Vue.config.productionTip = false
Axios.defaults.headers.common['Authorization'] = `Bearer ${store.getters.token}`;

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
